export const CHANGE_GROUP = 'CHANGE_GROUP';
export const SEND_ADD_GROUP_REQUEST = 'SEND_ADD_GROUP_REQUEST';
export const SEND_ADD_GROUP_SUCCESS = 'SEND_ADD_GROUP_SUCCESS';
export const SEND_ADD_GROUP_FAILURE = 'SEND_ADD_GROUP_FAILURE';

export const GET_ALL_GROUPS_REQUEST = 'GET_ALL_GROUPS_REQUEST';
export const GET_ALL_GROUPS_SUCCESS = 'GET_ALL_GROUPS_SUCCESS';
export const GET_ALL_GROUPS_FAILED = 'GET_ALL_GROUPS_FAILED';
